import { Snackbar } from "@mcleod/components";
import { Api, StringUtil } from "@mcleod/core";

export interface ZoneCoordinate { lat: number; lng: number; }
export interface GeographicZoneInput { operation: string; map_vendor: string; map_data: any; }
export enum WebMapVendor { GoogleMaps = "G", TrimbleMaps = "W", None = "N" }
export enum ZoneMapScreen { ZipZone = "ZZ", DispatchZone = "DZ", ZoneArea = "ZA", ZoneRegion = "ZR", ZoneSuperRegion = "ZS", MarketArea = "MA" }

export class MapZoneUtil {

    public static validateZoneMapVendor(mapVendor: string): boolean {
        if (StringUtil.isEmptyString(mapVendor)) {
            Snackbar.showWarningSnackbar("User is not configured with a Zone Map Vendor to plot the map.");
            return false;
        }
        if (mapVendor === WebMapVendor.None) {
            Snackbar.showWarningSnackbar("Please configure a Zone map Vendor in Global Settings or User Settings to display the Map.");
            return false;
        }
        return true;
    }

    public static async getGeographicZoneData(input: GeographicZoneInput): Promise<any> {
        const response = await Api.search("lme/dispatch/geographic-map", input);
        return response?.data[0] ?? null;
    }

    public static createGooglePolygon(zoneCoords: any[], i: number) {
        return new google.maps.Polygon({
            paths: zoneCoords[i],
            strokeColor: '#ff0000',
            strokeOpacity: 0.15,
            strokeWeight: 1,
            fillColor: '#ff0000',
            fillOpacity: 0.35
        });
    }

    public static polygonDataTrimble(coordinates: number[][]): GeoJSON.FeatureCollection<GeoJSON.Polygon> {
        return {
            type: 'FeatureCollection',
            features: [{
                type: 'Feature',
                properties: {},
                geometry: {
                type: 'Polygon',
                coordinates: [coordinates],
                },
            }],
        };
    }

}
